import styled from "styled-components";

const SchedulingPopoverWrapper = styled.div`
  display: flex;
  width: 800px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  .schedulingHeader {
    .schedulingTitle {
      font-size: 30px;
      font-weight: 500;
      line-height: 1.27;
      color: rgba(0, 0, 0, 0.85);
      margin: 0;
    }

    .schedulingSubTitle {
      margin: 0 0 10px 0;
    }
  }

  .schedulingTableWrapper {
    margin-top: 10px;
  }
`;

export default SchedulingPopoverWrapper;
